import { GeoJSON,WFS } from "ol/format"
import Overlay from 'ol/Overlay'
import {Fill, Stroke, Style,Circle,Text,Icon} from 'ol/style.js';
import { getVectorContext } from 'ol/render'
import WMTS from 'ol/source/WMTS';
import TileDebug from 'ol/source/TileDebug';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import {get as getProjection,Projection,transform} from 'ol/proj';
import {Tile as TileLayer, Vector as VectorLayer,Image as ImageLayer,VectorTile as VectorTileLayer} from 'ol/layer.js';
import {Vector as VectorSource, VectorTile as VectorTileSource,ImageWMS,TileWMS,XYZ } from 'ol/source.js';
import {bbox as bboxStrategy} from 'ol/loadingstrategy.js'
import Feature from 'ol/Feature';
import { LineString, Polygon, MultiLineString, MultiPolygon,MultiPoint,Point } from "ol/geom";
import MVT from 'ol/format/MVT.js';
import {getTopLeft, getWidth, getCenter,extend} from 'ol/extent'
import Intersects from 'ol/format/filter/Intersects.js';
import {WFS_LAYER_INDEX,WMS_LAYER_INDEX,WMTS_LAYER_INDEX, VECTOR_LAYER_INDEX,TEMPLATE_LAYER_INDEX,DEBUG_LAYER_INDEX}from '@/components/Constants/LayerIndex'

import axios from "axios";
import { Tile } from "ol";

function urlGwcToWms(url,layer){
  const key = 'gwc/service'
  const workspace = layer?layer.split(':')[0]:''
  return url.includes(key)?url.replace(key,workspace):url
}
function getDefaultLayerProps(props_data){
  const props = props_data || {}
  const opacity = props['opacity'] || 1
  const zIndex = props['zIndex'] || 0
  const minZoom = props['minZoom'] || null
  const maxZoom = props['maxZoom'] || null
  const style = props['style'] || null
  const layerProps = {
    opacity,
    zIndex
  }
  style && (layerProps['style'] = style)
  minZoom && (layerProps['minZoom'] = minZoom)
  maxZoom && (layerProps['maxZoom'] = maxZoom)
  return layerProps
}


/**
 * 地图工具集合
 * @author GuoYun
 */
export const CoreMap = {
  pointOverlay: null,
  flushTimer: null,
  WFS_LAYER_INDEX :WFS_LAYER_INDEX,
  WMS_LAYER_INDEX :WMS_LAYER_INDEX,
  WMTS_LAYER_INDEX :WMTS_LAYER_INDEX,
  VECTOR_LAYER_INDEX :VECTOR_LAYER_INDEX,
  TEMPLATE_LAYER_INDEX:TEMPLATE_LAYER_INDEX,
  DEBUG_LAYER_INDEX:DEBUG_LAYER_INDEX,
  Template_Style:new Style({
    image: new Icon({
      src:require('@/assets/images/position.png'),
      anchor: [0.5, 0],
      anchorOrigin: 'bottom-left',
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      scale: 1,
    }),
    stroke: new Stroke({
      color: "#FFFF00",
      width: 3
    }),
    fill: new Fill({
      color: "rgba(255,255,0,0.2)"
    }),
  }),
  Select_Style:new Style({
    image: new Icon({
      src:require('@/assets/images/positionr.png'),
      anchor: [0.5, 0],
      anchorOrigin: 'bottom-left',
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      scale: 1,
    }),
    stroke: new Stroke({
      color: "#FF0000",
      width: 3
    }),
    fill: new Fill({
      color: "rgba(255,0,0,0.2)"
    }),
  }),
  zoomFullExtent (map) {
    const extent = map.getView().get("extent")
    if (extent) {
      this.zoom(extent, map)
      return true
    } else {
      console.warn('缩放至全图失败！详细信息：当前地图未设置最大范围，无法缩放全图！')
      return false
    }
  },
  moveToPoint (pt, map, propsData) {
    const props = Object.assign({ flush: false, flushDuration: 3000, duration: 1000, maxZoom: null }, propsData)
    const maxZoom = props.maxZoom || map.getView().getZoom()

    map.getView().animate({
      center:pt,
      duration: props.duration,
      maxZoom: maxZoom,
    })
    if (props.flush) {
      this.flush(pt, map, { duration: props.flushDuration })
    }
  },
  zoom (extent, map, props = { maxZoom: 18, padding: [20, 20, 20, 20], duration: 1000 }) {
    map.getView().fit(extent, {
      duration: props.duration,
      padding: props.padding,
      maxZoom: props.maxZoom
    })

  },
  getMapBound(map,projection){
    // 获取地图边界
    const extent = this.getMapExtent(map)
    if (projection!=='EPSG:4326') {
      const prj = getProjection(projection)
      if (prj) {
        return [...transform([extent[0], extent[1]] , projection, 'EPSG:4326'),...transform([ extent[2], extent[3]], projection, 'EPSG:4326')]
      }else{
        console.warn(`未找到该【${projection}】投影！`)
        return extent
      }
    }else{
      return extent
    }
  },
  positionByGeojson (geojson, map,props) {
    var geometry = new GeoJSON(props).readGeometry(geojson)
    this.position(geometry.getExtent(), map)
  },

  flush (point, map, propsData) {
    const props = Object.assign({ duration: 3000 }, propsData)
    if (this.flushTimer) {
      clearTimeout(this.flushTimer)
    }
    const coordinate = Array.isArray(point) ? point : point.getCoordinates()
    if (this.pointOverlay) {
      this.removePointOverLay(map)
    }
    this.addPointOverlay(map)
    this.pointOverlay.setPosition(coordinate)
    this.flushTimer = setTimeout(() => {
      this.removePointOverLay(map)
    }, props.duration)
  },
  addPointOverlay (map) {
    var ele = document.createElement("div")
    ele.className = "point-flush-animation"
    this.pointOverlay = new Overlay({
      element: ele,
      positioning: 'center-center',
    })
    map.addOverlay(this.pointOverlay)
  },
  removePointOverLay (map) {
    map.removeOverlay(this.pointOverlay)
  },

  /**
   * 
   * @param {*} points 高亮边界坐标
   * @param {*} ctx  地图图层画笔 ————通过map的postcompose事件中获取 event.context
   * @param {ol.map} map  地图ol.map
   */
  heightLight (points, ctx, map) {
    let canvas = ctx.canvas
    let onePageCanvas = document.createElement('canvas')
    onePageCanvas.setAttribute('width', String(canvas.width))
    onePageCanvas.setAttribute('height', String(canvas.height))
    let ctx_ = onePageCanvas.getContext('2d')

    ctx_.rect(0, 0, canvas.width, canvas.height)
    ctx_.fillStyle = "rgba(3,24,51,0.60)"
    ctx_.fill()
    ctx_.globalCompositeOperation = 'destination-out'
    ctx_.beginPath()
    for (let i = 0, count = points.length; i < count; i++) {
      // 获取屏幕坐标
      let screenCoord = map.getPixelFromCoordinate(points[i])
      let x = screenCoord[0]
      let y = screenCoord[1]
      if (i === 0) {
        ctx_.moveTo(x, y)
      } else {
        ctx_.lineTo(x, y)
        ctx_.lineTo(x, y)
      }
    }
    ctx_.closePath()
    ctx_.fill()
    let patten = ctx.createPattern(onePageCanvas, "no-repeat")
    ctx.fillStyle = patten
    ctx.fillRect(0, 0, canvas.width, canvas.height)
  },

  /**
   * 局部地区显示裁剪
   * @param {*} feature 显示的区域要素
   * @param {*} layer   裁剪显示的图层
   */
  clipTileLayer (feature, layer) {
    layer.on("postrender", function (e) {
      let vectorContext = getVectorContext(e)
      e.context.globalCompositeOperation = 'destination-in'
      // feature 为裁剪显示的面要素
      vectorContext.drawFeature(feature, new Style({
        fill: new Fill({
          color: 'black',// 必需设置颜色
        })
      }))
      e.context.globalCompositeOperation = 'source-over'
    })
  },
  transform(coordinates,source,targe){
    const coords = []
    const array = coordinates[0]
    array.forEach(coord=>{
      try {
        const nCoord =  transform(coord,source,targe)
        coords.push(nCoord)
      } catch (error) {
        console.error(error);
      }
    })
    return coords
  },
  getMapExtent (map) {
    return map.getView().calculateExtent(map.getSize())
  },
  getDebugLayer(tileGrid){
    return  new TileLayer({
      source: new TileDebug({
        projection: 'EPSG:4326',             //地图投影坐标系
        tileGrid: tileGrid,  //获取瓦片网格信息
      }),
      zIndex: DEBUG_LAYER_INDEX
    })
  },
  getWMTSLayer(props_data){
    //todo
    const props =props_data || {}
    const url = props['url'] || ''
    const layer = props['layer'] || ''
    const style = props['style'] || ''
    const projection = props['projection'] || 'EPSG:4326' //瓦片坐标系
    const format = props['format'] || 'image/png'
    !props['zIndex'] && (props['zIndex'] = WMTS_LAYER_INDEX)
    const layerProps = getDefaultLayerProps(props)
    if (!url || !layer) {
      return
    }
    const matrixIds = []
    const resolutions =[]
    const prj = getProjection(projection)
    let size = getWidth(prj.getExtent()) / 256;
    for (let i = 1; i < 19; i++) {
      matrixIds.push(`${projection}:`+(i-1))
      resolutions.push(size/Math.pow(2,i))
    }
    return new TileLayer({
        ...layerProps,
        source: new WMTS({
          url,
          layer,
          matrixSet: projection,
          format, 
          projection,
          tileGrid: new WMTSTileGrid({// 投影坐标系
            origin: getTopLeft(prj.getExtent()),
            extent: prj.getExtent(),
            matrixIds,
            resolutions
          }),
    
          style,
          wrapX: true,
        })
    })
  },
  getXYZLayer(props_data){
    const props =props_data || {}
    const url = props['url'] || ''
    const layer = props['layer'] || ''
    const projection = props['projection'] || 'EPSG:3857'  //瓦片的坐标系，会自动将地图坐标转换成瓦片坐标
    const mapPrj = projection==='EPSG:3857'?'EPSG:900913':projection
    !props['zIndex'] && (props['zIndex'] = WMTS_LAYER_INDEX)
    const layerProps = getDefaultLayerProps(props)
    if (!url || !layer) {
      return
    }
    return new TileLayer({
      ...layerProps,
      source: new XYZ({
        crossOrigin: 'anonymous',
        url: url + `?layer=${layer}&Service=WMTS&tilematrixset=${mapPrj}&Request=GetTile&Version=1.0.0&Format=image/png&TileCol={x}&TileRow={y}&TileMatrix=${mapPrj}:{z}`,
        maxZoom: 18,
        projection,
      }),
    })
  },
  getWfsLayer(props_data){
    const props =props_data || {}
    const url = props['url'] || ''
    const layer = props['layer'] || ''
    const projection = props['projection'] || 'EPSG:4326' 
    !props['style'] && (props['style']={'stroke-width': 0.75,'stroke-color': 'white','fill-color': 'rgba(100,100,100,0.25)',})
    !props['zIndex'] && (props['zIndex'] = WFS_LAYER_INDEX)
    const layerProps = getDefaultLayerProps(props)

    return new VectorLayer({
      ...layerProps,
      source: new VectorSource({
        format: new GeoJSON(),
        url: function (extent) {
          return (
            url+
            '?service=WFS&version=1.1.0&request=GetFeature&typename=' +
            layer +
            '&outputFormat=application/json&srsname='
            + projection +
            '&bbox=' +
            extent.join(',') + ',' + 
            projection
          );
        },
        strategy: bboxStrategy,
      }),
    })
  },
  getWmsLayer(props_data){
    const props =props_data || {}
    const layer = props['layer'] || ''
    const url =props['url'] || ''
    const definition = props['definition'] || ''
    const projection = props['projection'] || 'EPSG:4326' 
    !props['zIndex'] && (props['zIndex'] = WMS_LAYER_INDEX)
    const layerProps = getDefaultLayerProps(props)
    const params = {
      'layers': layer,
      "VERSION":"1.1.1",
    }
    if (definition) {
      params.CQL_FILTER = definition
      params.exceptions= 'application/vnd.ogc.se_inimage'
    }
    return url.includes('gwc/service/wms')
    ?new TileLayer({...layerProps,source: new TileWMS({url,projection,params})})
    :new ImageLayer({...layerProps,source: new ImageWMS({url,projection,params})})
  },
  getMvtLayer(props_data){
    const props =props_data || {}
    const url = props['url'] || ''
    const layer = props['layer'] || ''
    const projection = props['projection'] || 'EPSG:4326' 
    const tileUrl = `${url}/gwc/service/wmts?REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&LAYER=${layer}&STYLE=&TILEMATRIX=${projection}:{z}&TILEMATRIXSET=${projection}&FORMAT=application/vnd.mapbox-vector-tile&TILECOL={x}&TILEROW={y}`
    !props['zIndex'] && (props['zIndex'] = WMS_LAYER_INDEX)
    const layerProps = getDefaultLayerProps(props)
    return new VectorTileLayer({
      ...layerProps,
      source: new VectorTileSource({
        tileUrlFunction:(tile)=>{
          return tileUrl.replace('{z}', tile[0]-1).replace('{x}', tile[1]).replace('{y}', tile[2]); 
        },
        format: new MVT(),
        projection
      })
    })
  },
  getVectorLayer(props_data){
    const props =props_data || {}
    const zIndex = props['zIndex'] || VECTOR_LAYER_INDEX
    const style = props['style'] ||  new Style({
      image: new Icon({
        src:require('@/assets/images/position.png'),
        anchor: [0.5, 0],
        anchorOrigin: 'bottom-left',
        anchorXUnits: 'fraction',
        anchorYUnits: 'pixels',
        scale: 1,
      }),
      stroke: new Stroke({
        color: "#FFFF00",
        width: 3
      }),
      fill: new Fill({
        color: "rgba(255,255,0,0.2)"
      }),
    })
    !props['style'] &&  (props['style'] = style)
    !props['zIndex'] && (props['zIndex'] = VECTOR_LAYER_INDEX)
    const layerProps = getDefaultLayerProps(props)
    return new VectorLayer({
      ...layerProps,
      source: new VectorSource(),
    })
  },
  writeTransaction(props_data){
    const props = props_data || {}
    const url = props['url'] || ''
    const workspace = props['workspace'] || ''
    const layer = props['layer'] || ''
    const projection = props['projection'] 
    const replaceWorkspace = props['replaceWorkspace'] 
    if (!url || !projection) {
      return new Promise((resolve, reject) => {
        reject('url or projection is null')
      })
    }
    const { srs ,srsName,isErrorAxisOrientation} = this.getStandardProjectionInfo(projection)

    const inserts = props['inserts'] || null
    const updates = props['updates'] || null
    const deletes = props['deletes'] || null
    const wfsSerializer = new WFS();
    const xmlSerializer = new XMLSerializer();
    const featureRequest = wfsSerializer.writeTransaction(inserts, updates, deletes, 
    {
      featureNS: workspace,//工作区URI
      featurePrefix: workspace,//工作区名称
      featureType: layer,//图层名称
      srsName: isErrorAxisOrientation?srs:srsName,//坐标系
      version:'1.1.0'
    })
    let requsetStr = xmlSerializer.serializeToString(featureRequest) 
    if (isErrorAxisOrientation) {
      requsetStr = requsetStr.replaceAll('srsName="[object Object]"',`srsName="${srsName}"`)
    } 
    return axios.post(url +'/wfs',requsetStr,{headers:{"Content-Type":"text/xml"}})
  },
  intersects(props_data){
    const props = props_data || {}
    const url = props['url'] || ''
    const workspace = props['workspace'] || ''
    const layer = props['layer']|| ''
    const geometry = props['geometry'] || null
    const geometryName = props['geometryName'] || 'geom'

    const projection = props['projection'] 
    if (!url || !projection) {
      return new Promise((resolve, reject) => {
        reject('url or projection is null')
      })
    }

    const { srs ,srsName,isErrorAxisOrientation} = this.getStandardProjectionInfo(projection)
    
    const filter =new Intersects(geometryName, geometry, isErrorAxisOrientation?srs:srsName)
    const wfsSerializer = new WFS();
    const xmlSerializer = new XMLSerializer();
    const featureRequest = wfsSerializer.writeGetFeature({
      featureNS: workspace,
      featurePrefix: workspace,
      featureTypes: [layer],
      outputFormat: 'application/json',
      srsName,
      filter,
    })
    let requsetStr = xmlSerializer.serializeToString(featureRequest) 
    if (isErrorAxisOrientation) {
      requsetStr = requsetStr.replaceAll('srsName="[object Object]"',`srsName="${srsName}"`)
    } 
    return axios.post(url +'/wfs',requsetStr,{headers:{"Content-Type":"text/xml"}})
  },
  getStandardProjectionInfo(projection){
    let srsName = ""
    let srs = null
    if (typeof projection ==='string' || projection instanceof String) {
      srsName = projection
      srs = getProjection(projection)
    }else{
      srsName = projection.getCode()
      srs = projection
    }
    const isErrorAxisOrientation = srs.getAxisOrientation()!=="enu"
    if(isErrorAxisOrientation){
      srs = new Projection({code: srsName,axisOrientation: 'enu'})
    }
    return {srs,srsName,isErrorAxisOrientation}
  },
  getFormatFeature(feature,geometryName='geom',originGeometryType){
    let geometry = feature.getGeometry().clone()
    if (originGeometryType && originGeometryType==='MultiLineString' &&  geometry instanceof LineString) {
      geometry = new MultiLineString([geometry.getCoordinates()])
    }else if ( originGeometryType && originGeometryType==='MultiPolygon'  && geometry instanceof Polygon) {
      geometry = new MultiPolygon([geometry.getCoordinates()])
    }
    const props = {}
    props[geometryName] = geometry
    const formatFeat = new Feature(props)
    formatFeat.setGeometryName(geometryName)
    return formatFeat
  },
  getEditorStyle(text){
    const styles = [
      new Style({
        image: new Circle({
          radius: 3,
          stroke: new Stroke({color: '#FFA500', width: 2})
        }),
        geometry: function(feature) {
          const geometry = feature.getGeometry();
          if (geometry instanceof Point) {
            return geometry;
          }
          const polygons = feature.getGeometry().getCoordinates();
          let coordinates = []
          if (geometry instanceof Polygon) {
            polygons.forEach(arc=>{
              coordinates.push.apply(coordinates, arc)
            })
          }else if (geometry instanceof MultiPolygon){
            polygons.forEach(p=>{
              p.forEach(arc=>{
                coordinates.push.apply(coordinates, arc)
              })
            })
          }
          return new MultiPoint(coordinates);
        }
      }),
      new Style({
        stroke: new Stroke({
          color: "#FFA500",
          width: 3
        }),
        fill: new Fill({
          color: "rgba(255,165,0,0.4)"
        }),
      })
    ]
    if (text) {
      styles.push(this.getTextStyle(text))
    }
    return styles
  },
  getTextStyle(text,props_data){
    const props = props_data || {}
    return new Style({
      text:new Text({
        text,
        textAlign: 'center',            //位置
        textBaseline: 'middle', 
        font:'15px sans-serif',        //基准线
        fill: new Fill({       //文本填充样式（即文字颜色)
          color: props.color || '#FFA500'
        }),
        // stroke: new Stroke({
        //     color: props.outline ||'#000', 
        //     width: props.width || 2
        // })
      })
    })
  },
  readFeatures(json,props){
    const format = new GeoJSON(props)
    return format.readFeatures(json)
  },
  getExtent(features){
    const array = Array.isArray(features)?features:[features]
    let extent = null
    array.forEach(feature=>{
      const ex=  feature.getGeometry()?.getExtent()
      if (!extent) {
        extent = ex
      }else if(ex){
        extent = extend(extent,ex)
      }
    })
    return extent
  },
  repairGeometry(feature){
    const geometry = feature.getGeometry()
    const coords = geometry.getCoordinates()
    if (geometry instanceof Polygon) {
      console.log("Polygon");
      const re = this.repairPolygon(coords)
      geometry.setCoordinates(re)
    }else if (geometry instanceof MultiPolygon) {
      const re = []
      coords.forEach(p=>{
        const rp = this.repairPolygon(p)
        re.push(rp)
      })
      geometry.setCoordinates(re)
    }
    feature.setGeometry(geometry)
  },
  repairPolygon(p){
    let last = null
    for (let i = 0; i < p.length; i++) {
      const arc = p[i]
      const newArc = []
      arc.forEach(pt=>{
        if (last) {
          if(last[0]!==pt[0] && last[1]!==pt[1]){
            newArc.push(pt)
            last = pt
          }
        }else{
          last = pt
          newArc.push(pt)
        }
      })
      p[i] = newArc
    }
    return p
  },
  
}
